import { Modal, ModalOverlay, UseModalProps } from '@chakra-ui/react';

import { ModalContentForm } from './components/modal-content-form';

type Props = Pick<UseModalProps, 'isOpen' | 'onClose'> & {
  gameTitle: string;
  gameSlug: string;
  onSuccess?: () => void;
};

export const AddReviewModal = ({ isOpen, onClose, gameTitle, gameSlug, onSuccess }: Props) => {
  const handleFormSubmit = () => {
    onSuccess();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
      isCentered
      size="2xl"
      variant="review">
      <ModalOverlay />
      <ModalContentForm
        gameTitle={gameTitle}
        gameSlug={gameSlug}
        onSuccess={handleFormSubmit}
        onClose={onClose}
      />
    </Modal>
  );
};
